export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
}

export interface LiveMatch {
  id: string;
  homeTeam: string;
  awayTeam: string;
  homeScore: number | null;
  awayScore: number | null;
  league: string;
  status: 'live' | 'upcoming' | 'finished';
  statusText: string;
  startTime: string;
  category: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  { name: '足球', slug: 'football', icon: 'ri-football-line', articleCount: 128 },
  { name: '篮球', slug: 'basketball', icon: 'ri-basketball-line', articleCount: 96 },
  { name: '网球', slug: 'tennis', icon: 'ri-base-station-line', articleCount: 54 },
  { name: '电竞', slug: 'esports', icon: 'ri-gamepad-line', articleCount: 87 },
  { name: '综合', slug: 'general', icon: 'ri-medal-line', articleCount: 42 },
];

export const liveMatches: LiveMatch[] = [
  {
    id: 'match-1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    league: '西甲联赛',
    status: 'live',
    statusText: '进行中 78\'',
    startTime: '2026-08-08T20:00:00',
    category: 'football',
  },
  {
    id: 'match-2',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 102,
    league: 'NBA常规赛',
    status: 'live',
    statusText: '第四节 5:32',
    startTime: '2026-08-08T19:30:00',
    category: 'basketball',
  },
  {
    id: 'match-3',
    homeTeam: '曼彻斯特城',
    awayTeam: '阿森纳',
    homeScore: null,
    awayScore: null,
    league: '英超联赛',
    status: 'upcoming',
    statusText: '今日 22:00',
    startTime: '2026-08-08T22:00:00',
    category: 'football',
  },
  {
    id: 'match-4',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: null,
    awayScore: null,
    league: 'ATP大师赛',
    status: 'upcoming',
    statusText: '明日 16:30',
    startTime: '2026-08-09T16:30:00',
    category: 'tennis',
  },
  {
    id: 'match-5',
    homeTeam: 'T1战队',
    awayTeam: 'Gen.G',
    homeScore: null,
    awayScore: null,
    league: 'LCK夏季赛',
    status: 'upcoming',
    statusText: '明日 18:00',
    startTime: '2026-08-09T18:00:00',
    category: 'esports',
  },
  {
    id: 'match-6',
    homeTeam: 'AC米兰',
    awayTeam: '国际米兰',
    homeScore: 3,
    awayScore: 2,
    league: '意甲联赛',
    status: 'finished',
    statusText: '已结束',
    startTime: '2026-08-07T21:00:00',
    category: 'football',
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026世界杯预选赛亚洲区：中国队战胜日本队，晋级形势大优',
    excerpt: '在2026年世界杯亚洲区预选赛的关键战役中，中国队以2:1击败日本队，取得四连胜，出线形势一片大好。本场比赛中国队展现出色的战术执行力。',
    content: '<p>在2026年世界杯亚洲区预选赛的关键战役中，中国队以2:1击败日本队，取得四连胜，出线形势一片大好。本场比赛中国队展现出色的战术执行力和顽强的拼搏精神。</p><p>上半场第23分钟，武磊接到张玉宁的精妙直塞球，冷静推射远角得手，为中国队首开纪录。日本队在丢球后加强进攻，但中国队的防线在蒋光太的统领下稳如磐石。</p><p>下半场第67分钟，日本队通过一次角球机会扳平比分。然而仅仅8分钟后，替补上场的韦世豪在禁区外轰出一记世界波，皮球直挂球门死角，帮助中国队再次领先。</p><p>赛后主教练表示，球队的整体表现令人满意，特别是在防守端的纪律性和进攻端的效率方面都有了显著提升。目前中国队在小组中积15分，领先第二名5分，晋级世界杯的希望大大增加。</p>',
    category: '足球',
    categorySlug: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20celebrating%20victory%20on%20stadium%20pitch%2C%20dramatic%20sports%20photography%2C%20players%20in%20red%20jerseys%20embracing%2C%20stadium%20lights%2C%20green%20grass%2C%20atmospheric%20lighting%2C%20professional%20sports%20photojournalism%20style&width=800&height=500&seq=article-football-1&orientation=landscape',
    author: '体育观察员',
    publishDate: '2026-08-08',
    readCount: 52890,
    tags: ['世界杯', '预选赛', '中国队', '日本队'],
  },
  {
    id: 'article-2',
    title: 'NBA新赛季前瞻：湖人三巨头能否冲击总冠军？',
    excerpt: '随着NBA新赛季即将拉开帷幕，洛杉矶湖人队的阵容调整引发广泛关注。詹姆斯、戴维斯与新援组成的三巨头能否在新赛季冲击总冠军？',
    content: '<p>随着NBA新赛季即将拉开帷幕，洛杉矶湖人队的阵容调整引发广泛关注。詹姆斯、戴维斯与新援组成的三巨头能否在新赛季冲击总冠军？这是我们今天要深入探讨的话题。</p><p>湖人队在休赛期的操作可谓十分积极。除了保留了詹姆斯和戴维斯的核心组合外，球队还通过交易引进了一位全明星级别的后卫，大大增强了后场的进攻火力和组织能力。</p><p>从阵容深度来看，湖人队的替补席也得到了明显补强。几名经验丰富的老将和充满活力的年轻球员的加入，使得球队在各个位置上都有了可靠的轮换选择。</p><p>不过，西部竞争依然激烈。掘金、勇士、太阳等球队同样实力强劲。湖人想要冲出西部，除了保持核心球员的健康外，还需要在新赛季初期尽快磨合阵容，建立良好的化学反应。</p>',
    category: '篮球',
    categorySlug: 'basketball',
    coverImage: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20action%20shot%2C%20Los%20Angeles%20Lakers%20player%20dunking%2C%20professional%20basketball%20arena%20with%20dramatic%20lighting%2C%20gold%20and%20purple%20jersey%2C%20sports%20photography%20style%2C%20high%20intensity%20action&width=800&height=500&seq=article-basketball-1&orientation=landscape',
    author: '篮坛观察',
    publishDate: '2026-08-07',
    readCount: 42150,
    tags: ['NBA', '湖人', '詹姆斯', '总冠军'],
  },
  {
    id: 'article-3',
    title: '温网男单决赛：阿尔卡拉斯五盘大战逆转夺冠',
    excerpt: '2026年温布尔登网球锦标赛男单决赛上演史诗级对决，西班牙新星阿尔卡拉斯在两盘落后的情况下连扳三盘，逆转战胜对手，首次捧起温网冠军奖杯。',
    content: '<p>2026年温布尔登网球锦标赛男单决赛上演史诗级对决，西班牙新星阿尔卡拉斯在两盘落后的情况下连扳三盘，以3-2逆转战胜对手，首次捧起温网冠军奖杯。整场比赛历时4小时38分钟。</p><p>前两盘比赛中，对手发挥出色，以6-4、7-5取得领先。然而阿尔卡拉斯展现出了超乎年龄的心理素质，在第三盘抢七中以7-4扳回一盘。</p><p>随后的比赛中，阿尔卡拉斯越战越勇，体能优势也逐渐显现。第四盘以6-3轻松拿下，决胜盘中更是以一记精彩的穿越球完成关键破发，最终以6-4锁定胜局。</p><p>赛后阿尔卡拉斯表示："这是我职业生涯最重要的一场胜利，我永远不会忘记这一刻。"这场胜利也使他成为公开赛年代以来第五位在温网实现两盘落后逆转夺冠的选手。</p>',
    category: '网球',
    categorySlug: 'tennis',
    coverImage: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20championship%20men%20singles%20final%2C%20player%20holding%20golden%20trophy%20on%20green%20grass%20court%2C%20white%20tennis%20outfit%2C%20professional%20sports%20photography%2C%20elegant%20and%20prestigious%20atmosphere%2C%20historic%20venue&width=800&height=500&seq=article-tennis-1&orientation=landscape',
    author: '网球视界',
    publishDate: '2026-08-07',
    readCount: 38720,
    tags: ['温网', '阿尔卡拉斯', '大满贯', '网球'],
  },
  {
    id: 'article-4',
    title: '英雄联盟S16全球总决赛：四强全部产生，LPL双雄在列',
    excerpt: '英雄联盟S16全球总决赛八强赛全部结束，四强名额尘埃落定。LPL赛区的两支队伍成功晋级半决赛，展现出中国电竞的强大实力。',
    content: '<p>英雄联盟S16全球总决赛八强赛全部结束，四强名额尘埃落定。LPL赛区的两支队伍成功晋级半决赛，展现出中国电竞的强大实力和深厚底蕴。</p><p>在八强赛中，一号种子以3:1的比分击败了LCK强敌，展现出极强的战术执行力和个人能力。特别是在第三局比赛中，中单选手的发挥堪称神级，以10-0-8的完美数据带领团队取胜。</p><p>另一支LPL队伍同样表现不俗，以3:0横扫欧洲劲旅。三局比赛中均展现出碾压级的对线实力和完美的团战配合。</p><p>半决赛将在本周末举行，两支LPL队伍将分别对阵韩国赛区的两支强队。如果两队均能获胜，LPL赛区将创造历史，在决赛中上演内战。电竞迷们对即将到来的半决赛充满期待。</p>',
    category: '电竞',
    categorySlug: 'esports',
    coverImage: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20esports%20arena%20with%20large%20crowd%20and%20stage%2C%20professional%20gaming%20setup%20with%20colorful%20lights%2C%20epic%20stage%20design%2C%20players%20competing%20on%20stage%2C%20grand%20esports%20event%20atmosphere&width=800&height=500&seq=article-esports-1&orientation=landscape',
    author: '电竞前线',
    publishDate: '2026-08-06',
    readCount: 76300,
    tags: ['英雄联盟', 'S16', 'LPL', '电竞'],
  },
  {
    id: 'article-5',
    title: '欧冠小组赛抽签结果出炉：死亡之组再现',
    excerpt: '2026-2027赛季欧冠联赛小组赛抽签仪式在瑞士尼翁举行。拜仁、巴黎圣日耳曼、AC米兰被分入同一小组，堪称"死亡之组"。',
    content: '<p>2026-2027赛季欧冠联赛小组赛抽签仪式在瑞士尼翁举行。拜仁慕尼黑、巴黎圣日耳曼、AC米兰被分入B组，堪称本赛季的"死亡之组"，这三支欧洲顶级豪门的对决将成为小组赛阶段最大的看点。</p><p>除了B组外，其他小组同样不乏看点。卫冕冠军皇家马德里与英超劲旅阿森纳分在A组，两支技术流球队的较量值得期待。C组的曼城被普遍看好能够轻松出线，而D组的巴塞罗那则需要在多特蒙德和马德里竞技的夹击中突围。</p><p>小组赛首轮将于9月15日正式打响。各大豪门将在这个欧洲最高水平的俱乐部赛事中展开激烈角逐。足球迷们已经迫不及待地想要看到这些顶级对决的上演。</p>',
    category: '足球',
    categorySlug: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=UEFA%20Champions%20League%20draw%20ceremony%2C%20football%20club%20logos%20displayed%20on%20large%20screen%2C%20elegant%20event%20hall%2C%20golden%20trophy%20on%20stage%2C%20prestigious%20European%20football%20atmosphere%2C%20professional%20event%20photography&width=800&height=500&seq=article-football-2&orientation=landscape',
    author: '足球世界',
    publishDate: '2026-08-06',
    readCount: 35200,
    tags: ['欧冠', '抽签', '死亡之组', '拜仁'],
  },
  {
    id: 'article-6',
    title: 'CBA新赛季赛程公布：揭幕战广东对阵辽宁',
    excerpt: 'CBA联盟正式公布2026-2027赛季常规赛赛程。揭幕战将由卫冕冠军广东宏远对阵上赛季亚军辽宁本钢，强强对话令人期待。',
    content: '<p>CBA联盟正式公布2026-2027赛季常规赛赛程。新赛季将于10月18日拉开帷幕，揭幕战将由卫冕冠军广东宏远对阵上赛季亚军辽宁本钢，这场南北大战注定精彩纷呈。</p><p>本赛季常规赛共设56轮比赛，将持续到2027年4月。相比上赛季，赛程安排更加紧凑，背靠背比赛的次数有所减少，这将有助于球员保持更好的竞技状态和减少伤病风险。</p><p>值得关注的是，本赛季有多支球队进行了大幅度的阵容调整和外援更换。北京首钢引进了前NBA球员，上海大鲨鱼也签下了欧洲顶级后卫，各支球队的竞争力都有所提升。</p><p>CBA联盟表示，新赛季将继续提升赛事运营水平和球迷观赛体验，推出更多数字化互动功能，让更多篮球爱好者能够全方位感受CBA的魅力。</p>',
    category: '篮球',
    categorySlug: 'basketball',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20basketball%20CBA%20game%20action%2C%20two%20players%20competing%20for%20rebound%20on%20court%2C%20packed%20indoor%20arena%2C%20red%20and%20white%20jerseys%2C%20dramatic%20sports%20moment%2C%20professional%20basketball%20photography&width=800&height=500&seq=article-basketball-2&orientation=landscape',
    author: 'CBA观察',
    publishDate: '2026-08-05',
    readCount: 28800,
    tags: ['CBA', '广东', '辽宁', '赛程'],
  },
  {
    id: 'article-7',
    title: '中国网球公开赛：郑钦文横扫对手晋级八强',
    excerpt: '2026年中国网球公开赛女单第三轮，中国金花郑钦文以6-2、6-3直落两盘战胜世界排名第15位的对手，强势晋级八强。',
    content: '<p>2026年中国网球公开赛女单第三轮，中国金花郑钦文以6-2、6-3直落两盘战胜世界排名第15位的对手，强势晋级八强。整场比赛仅耗时72分钟。</p><p>郑钦文在本场比赛中展现出了极高的竞技水平和自信心。首盘比赛中她三次破发得手，发球局更是全部保发，仅用28分钟就以6-2拿下首盘。第二盘虽然遭遇了一些抵抗，但郑钦文在关键分上的处理更加成熟冷静，最终以6-3锁定胜局。</p><p>"我感觉自己状态越来越好，每一场比赛都在进步，"郑钦文赛后说道，"主场观众的支持给了我巨大的力量。"</p><p>四分之一决赛中，郑钦文将面对赛会3号种子。如果能够获胜，她将刷新个人在中网的最佳战绩。</p>',
    category: '网球',
    categorySlug: 'tennis',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20tennis%20player%20serving%20ball%20on%20hard%20court%2C%20tennis%20racket%20in%20air%2C%20professional%20tennis%20tournament%2C%20blue%20court%20surface%2C%20intense%20sports%20moment%2C%20athletic%20and%20powerful%20composition&width=800&height=500&seq=article-tennis-2&orientation=landscape',
    author: '中网特派记者',
    publishDate: '2026-08-05',
    readCount: 45800,
    tags: ['中网', '郑钦文', '网球', '中国金花'],
  },
  {
    id: 'article-8',
    title: 'DOTA2国际邀请赛：中国战队夺冠，创造奖金纪录',
    excerpt: '在刚刚结束的DOTA2国际邀请赛（TI15）总决赛中，中国战队以3:1击败欧洲劲旅，夺得冠军。本届赛事总奖金池突破5000万美元，创下电竞历史新高。',
    content: '<p>在刚刚结束的DOTA2国际邀请赛（TI15）总决赛中，中国战队以3:1击败欧洲劲旅，成功夺得冠军盾牌。本届赛事总奖金池突破5000万美元，再次刷新了电竞历史最高奖金纪录。</p><p>总决赛堪称电竞史上的经典对决。首局比赛中国战队在劣势局面下凭借完美团战翻盘，极大地提振了士气。虽然第二局被对手扳回一城，但中国战队迅速调整状态，在随后的两局比赛中展现出了统治级的表现。</p><p>队长在捧杯时激动地表示："这个冠军我们等了太久，感谢所有支持我们的粉丝，这是我们共同的荣耀。"</p><p>此次夺冠不仅为中国电竞增添了浓墨重彩的一笔，也进一步证明了中国在全球电竞领域的强大实力和深厚底蕴。</p>',
    category: '电竞',
    categorySlug: 'esports',
    coverImage: 'https://readdy.ai/api/search-image?query=Dota%202%20The%20International%20championship%20celebration%2C%20esports%20team%20lifting%20trophy%20on%20stage%20with%20confetti%2C%20grand%20arena%20with%20thousands%20of%20fans%2C%20epic%20gaming%20moment%2C%20colorful%20stage%20lighting&width=800&height=500&seq=article-esports-2&orientation=landscape',
    author: '电竞之声',
    publishDate: '2026-08-04',
    readCount: 92100,
    tags: ['DOTA2', 'TI15', '冠军', '电竞'],
  },
  {
    id: 'article-9',
    title: '中超联赛：上海海港逆转获胜继续领跑积分榜',
    excerpt: '中超联赛第20轮，上海海港在客场0:1落后的情况下连入三球，以3:1逆转战胜对手，继续稳坐积分榜首位。',
    content: '<p>中超联赛第20轮，上海海港在客场0:1落后的情况下连入三球，以3:1逆转战胜对手，继续稳坐积分榜首位，向着联赛冠军又迈进了一步。</p><p>上半场比赛，主队凭借一次反击机会率先破门，上海海港带着0:1的劣势进入中场休息。然而下半场风云突变，上海海港展现出了冠军球队的韧性。</p><p>第55分钟，外援前锋利用个人能力扳平比分。随后第68分钟和第82分钟，上海海港再入两球，完成了精彩的逆转好戏。主教练的临场换人调整收到了奇效，替补上场的中场球员贡献了两次助攻。</p><p>此役过后，上海海港以48分继续领跑积分榜，领先第二名5分。在联赛还剩10轮的情况下，上海海港的夺冠前景被广泛看好。</p>',
    category: '足球',
    categorySlug: 'football',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20match%2C%20players%20celebrating%20goal%20in%20red%20jerseys%2C%20packed%20football%20stadium%20at%20night%2C%20dramatic%20stadium%20lighting%2C%20professional%20football%20match%20photography%2C%20passionate%20celebration&width=800&height=500&seq=article-football-3&orientation=landscape',
    author: '中超直通车',
    publishDate: '2026-08-04',
    readCount: 31500,
    tags: ['中超', '上海海港', '逆转', '积分榜'],
  },
  {
    id: 'article-10',
    title: '奥运会倒计时两年：中国代表团各项目备战全面提速',
    excerpt: '距离2028洛杉矶奥运会还有整整两年时间，中国体育代表团的各项备战工作已全面提速。多个重点项目均有亮眼表现和人才涌现。',
    content: '<p>距离2028洛杉矶奥运会还有整整两年时间，中国体育代表团的各项备战工作已全面提速。从传统优势项目到新兴突破项目，中国体育健儿正在为两年后的奥运盛会做着最充分的准备。</p><p>在传统优势项目方面，跳水、举重、乒乓球、射击等项目的梯队建设十分完善，一批年轻选手已经在国际大赛中崭露头角。特别是在跳水项目上，新一代"梦之队"已经在世锦赛上展现出了统治级的实力。</p><p>田径和游泳这两个金牌大户项目也有了显著进步。多名选手在今年的世锦赛上创造了个人最好成绩，部分项目已经具备了在奥运会上争夺奖牌的实力。</p><p>此外，滑板、攀岩、冲浪等新增奥运项目的国家队也在紧锣密鼓地训练备战。体育总局表示，将全力支持各项目的备战工作，力争在洛杉矶奥运会上取得优异成绩。</p>',
    category: '综合',
    categorySlug: 'general',
    coverImage: 'https://readdy.ai/api/search-image?query=Olympic%20Games%20preparation%20training%20scene%2C%20Chinese%20athletes%20training%20in%20various%20sports%20facilities%2C%20modern%20sports%20complex%2C%20athletic%20and%20dynamic%20composition%2C%20inspirational%20sports%20photography%2C%20clean%20and%20bright%20training%20environment&width=800&height=500&seq=article-general-1&orientation=landscape',
    author: '奥运频道',
    publishDate: '2026-08-03',
    readCount: 19800,
    tags: ['奥运会', '备战', '中国代表团', '洛杉矶'],
  },
];

export const statsData = [
  { label: '赛事直播', value: '12,800+', icon: 'ri-live-line', description: '累计直播场次' },
  { label: '活跃用户', value: '3,200万+', icon: 'ri-user-heart-line', description: '月活跃用户数' },
  { label: '数据分析', value: '50万+', icon: 'ri-bar-chart-box-line', description: '数据模型条数' },
  { label: '合作伙伴', value: '200+', icon: 'ri-team-line', description: '全球合作机构' },
];

export const communityPosts = [
  {
    id: 'post-1',
    user: '足球达人小王',
    avatar: '',
    content: '昨晚那场欧冠比赛太精彩了！皇马的反击速度简直离谱，姆巴佩那个进球我看十遍都不够！大家觉得今年皇马能走多远？',
    likes: 2345,
    comments: 567,
    time: '2小时前',
  },
  {
    id: 'post-2',
    user: '篮球迷小李',
    avatar: '',
    content: 'NBA新赛季湖人三巨头确实有看头，但我觉得掘金才是最大热门。约基奇太全能了，根本无解啊！你们觉得呢？',
    likes: 1890,
    comments: 423,
    time: '3小时前',
  },
  {
    id: 'post-3',
    user: '电竞狂人',
    avatar: '',
    content: 'LPL两支队伍进S16四强了！今年真的是最有希望的一年，感觉冠军就在眼前！大家一起为LPL加油！',
    likes: 5678,
    comments: 1234,
    time: '5小时前',
  },
];